import React from 'react';
import styled from 'styled-components';
import { localizationService } from '@shared-services/localization-service';
import { useBookingContext } from '../Context';
import { PricingType } from '../types';
import PricingIcon from './icons/PricingIcon';

const { str } = localizationService;

const BookingPricingMetaSection = () => {
    const { pricingType, price, isPaidNativeBookingAvailable } =
        useBookingContext();

    let priceValue = str(`ui.runtimessr.calbooking.meta.price.free`);

    if (isPaidNativeBookingAvailable && pricingType === PricingType.PAID) {
        // TODO: formatted price will be provided later
        const formattedPrice = `$${price}`;
        priceValue = formattedPrice;
    }

    return (
        <Container className='cal-booking-price-meta-section'>
            <Icon aria-hidden='true' width={18} height={18} />
            <Price data-auto='cal-booking-price-value'>{priceValue}</Price>
        </Container>
    );
};

export default BookingPricingMetaSection;

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: var(--cal-spacing-2);
    font-size: 0.875rem;
    line-height: 1.25rem;
    margin-bottom: var(--cal-spacing-4);
`;

const Icon = styled(PricingIcon)`
    fill: transparent;
    flex-shrink: 0;
    // need to align with other cal icons
    margin-inline: -1px;
`;

const Price = styled.div`
    position: relative;
    max-width: 100%;
    word-break: break-word;
    font-weight: 500;
`;
